import moment from 'moment-timezone';

const isMidnightTo = (momentValue) => moment(momentValue).format('HH:mm:SSS') === '23:59:999';

export default isMidnightTo;
